import { render, staticRenderFns } from "./leafStandard.vue?vue&type=template&id=3e2636cd"
import script from "./leafStandard.vue?vue&type=script&lang=js"
export * from "./leafStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports